define.alias("shared/components/shared/publish/switcher/item/business-button", "settings/components/shared/publish/switcher/item/business-button");